module.exports = __webpack_public_path__ + "img/ico-8.343d29bf.svg";